module.exports = require("@tiptap/extension-strike");